import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  sender_id: yup
    .string()
    .required("Sender ID is required")
    .max(11, "Sender ID must not be more than 11 characters")
    .matches(/^[A-Za-z0-9 ]+$/, "Sender ID must not contain special characters")
    .matches(/^[^0-9]/, "Sender ID must not begin with a number"),
});

const useValidation = ({ ...formData }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formData,
    },
  });
};

export default useValidation;
